import { z } from "zod";

export const uploadSchema = z.object({
  typeCode: z.enum(["01", "02", "03", "04", "11", "12", "13", "14", "01A"], {
    message: "Invoice type is required",
  }),
  strictValidation: z.boolean().optional().default(false),
  mappingProfileId: z.string().uuid().optional(),
  file: z
    .instanceof(FileList)
    .refine((files) => files.length === 1, {
      message: "File is required",
    })
    .refine((files) => files[0]?.size <= 5 * 1024 * 1024, {
      message: "File size must be less than or equal to 5MB",
    })
    .refine(
      (files) =>
        [
          "text/csv",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ].includes(files[0]?.type),
      { message: "Unsupported file type. Only .xlsx file is allowed" }
    ),
});

export const updateFileSchema = uploadSchema.pick({
  file: true,
});

export type UploadFormData = z.infer<typeof uploadSchema>;
export type UpdateUploadFormData = z.infer<typeof updateFileSchema>;
